import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { API, errMsg } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    try {
      await API.post("/auth/reset-password", { token: params.get("token") || "", password });
      navigate("/login");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <Logo />
        <h1 className="mt-10 font-serif text-3xl font-bold tracking-tight">Choose a new password</h1>
        <form onSubmit={submit} className="mt-6 space-y-5">
          {error && <div className="bg-destructive/10 border border-destructive/30 text-destructive text-sm px-4 py-3 rounded-md" data-testid="reset-error">{error}</div>}
          <div className="space-y-2">
            <Label htmlFor="password">New password</Label>
            <Input id="password" data-testid="reset-password-input" type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirm">Confirm new password</Label>
            <Input id="confirm" data-testid="reset-confirm-input" type="password" required
              value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat your password" />
          </div>
          <Button type="submit" data-testid="reset-submit-btn" disabled={loading} className="w-full">
            {loading ? "Updating…" : "Update password"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-muted-foreground">
          <Link to="/login" className="text-primary hover:underline">← Back to log in</Link>
        </p>
      </div>
    </div>
  );
}
